// extracted by mini-css-extract-plugin
module.exports = {"l1g5nbo9":"l1g5nbo9"};